// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__kbK3g","heading":"Heading_heading__2J5hE"};